/* eslint-disable jsx-a11y/label-has-associated-control */
import type { Props } from './type'

import { Text } from 'components/common/atoms/typography'

import {
  Label,
  CheckboxContainer,
  HiddenCheckbox,
  StyledCheckbox,
  Icon,
  CheckboxBackground,
} from './styled'

export const Checkbox: React.FC<Props> = (props) => {
  const { checked, onCheck, id, name, error, text, disabled, $width, $margin, $mMargin } = props

  return (
    <Label htmlFor={id} $width={$width} $margin={$margin} $mMargin={$mMargin}>
      <CheckboxContainer>
        <HiddenCheckbox
          id={id}
          name={name}
          checked={checked}
          onChange={(e) => {
            e.stopPropagation()
            onCheck(e.target.checked)
          }}
          disabled={disabled}
        />
        <StyledCheckbox checked={checked} error={error}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
          <CheckboxBackground error={error} />
        </StyledCheckbox>
      </CheckboxContainer>
      {text && (
        <Text $size="16px" $mSize="16px" $lineHeight="18px" $mLineHeight="18px">
          {text}
        </Text>
      )}
    </Label>
  )
}
